import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy } from "lucide-react";

export default function Winners() {
  const [winners, setWinners] = useState([]);

  useEffect(() => {
    api.get("/winners").then(({ data }) => setWinners(data.winners));
  }, []);

  return (
    <div className="grid-bg min-h-[calc(100vh-73px)]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tighter mb-2">
          Hall of Winners
        </h1>
        <p className="text-zinc-500 mb-12">Every winner. Every steal. Every last penny.</p>

        {winners.length === 0 ? (
          <div className="card-surface p-12 text-center">
            <Trophy className="mx-auto text-zinc-600 mb-3" size={32} />
            <p className="text-zinc-400">No winners yet. Be the first!</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {winners.map((w) => (
              <div key={w.id} className="card-surface p-5" data-testid={`winner-${w.id}`}>
                <div className="aspect-video rounded-lg overflow-hidden bg-black mb-4">
                  <img src={w.image_url} alt={w.title} className="w-full h-full object-cover" />
                </div>
                <h3 className="font-display font-bold text-lg mb-1">{w.title}</h3>
                <div className="flex items-center justify-between mt-3 pt-3 border-t border-white/5 text-sm">
                  <div>
                    <div className="text-[10px] uppercase tracking-widest text-zinc-500">
                      Winner
                    </div>
                    <div className="font-medium">{w.winner_name || "—"}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-[10px] uppercase tracking-widest text-zinc-500">
                      Final price
                    </div>
                    <div className="font-mono-nums text-[#FBBF24] font-bold">
                      ${w.final_price?.toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
